export const ACCOUNT_TYPE = {
  STUDENT: "Student",
  CLIENT: "Learner",
  LEARNER: "Learner",
  INSTRUCTOR: "Instructor",
  PRACTITIONER: "Practitioner",
  ADMIN: "Admin",
  ORG_ADMIN: "OrgAdmin",
}

export const COURSE_STATUS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
}
